export default {
	campaign : {
		categories :[],
		failure:[],
		success:[],
		available:[],
		table:[]
	}
}